import SEO from '../components/SEO';
import DeveloperToolsPanel from '../components/DeveloperToolsPanel';

export default function URLToolPage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "URL Encoder & Decoder - JsonToonCraft",
    "applicationCategory": "DeveloperApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "Free URL encoder and decoder tool. Encode and decode URL components, query strings, and parameters instantly.",
    "featureList": [
      "URL encoding",
      "URL decoding",
      "Query string encoding",
      "Percent encoding",
      "Instant conversion",
      "Copy to clipboard"
    ]
  };

  return (
    <>
      <SEO
        title="URL Encoder & Decoder - Encode and Decode URLs Online | JsonToonCraft"
        description="Free URL encoder and decoder tool. Encode and decode URL components, query strings, and parameters instantly. Perfect for web development and API work."
        keywords="URL encoder, URL decoder, encode URL, decode URL, URL encoding, percent encoding, query string encoder"
        canonicalUrl="https://jsontooncraft.com/dev-tools/url-encoder"
        structuredData={structuredData}
      />

      <DeveloperToolsPanel initialTool="url" />
    </>
  );
}
